import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { navStore } from '@mcn-platform/models';
// export type GlobalErrorDialogProps = {
//   title: string,
// };
const GlobalErrorDialog = () => {
    const { errorDialog } = navStore;
    const handleClose = () => {
        errorDialog.closeError();
    };
    return (_jsxs(Dialog, { open: errorDialog.open, PaperProps: { sx: { minWidth: '50%' } }, children: [_jsx(DialogTitle, { children: errorDialog.title }), _jsx(DialogContent, { sx: { mx: 3 }, children: _jsx(Typography, { variant: "subtitle1", component: "div", children: errorDialog.message }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: handleClose, children: "Close" }) })] }));
};
export default observer(GlobalErrorDialog);
//# sourceMappingURL=GlobalErrorDialog.js.map